import { useLayoutEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../context/auth";
import { setShowSearch } from "../../store/appConfigsSlice";
import { BalanceRechargeComponent, SeoTags } from "../../components";

const BalancePage = () => {
  const { isAuth } = useAuth();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  if (!isAuth) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <SeoTags pageKey="balancePage" />
      <BalanceRechargeComponent />
    </>
  );
};

export default withTranslation()(BalancePage);
